<template>
  <div v-if="hasCategories" class="filter-category-selector">
    <ul role="tree" aria-labelledby="filter-category-selector-title">
      <oie-base-node
        v-for="category in categories"
        :key="category.code"
        :node="category"
        :always-show-children="true"
        :active-node="state.selectedCategory">
      </oie-base-node>
    </ul>
  </div>
</template>

<script>
import { state, hasCategories, hasVehicles, hasFacets, DEFAULT_CATEGORY_NODE, selectedCategory, FILTER_TYPES } from '@/store/filters'

export default {
  data() {
    return {
      state,
      selectedCategory
    }
  },
  computed: {
    hasCategories() { return hasCategories() },
    hasVehicles() { return hasVehicles() },
    hasFacets() { return hasFacets() },
    categories() {
      return [
        {
          name: this.tStatic('allCategories'),
          code: DEFAULT_CATEGORY_NODE,
          children: state.categories
        }
      ]
    }
  },
  mounted() {
    this.subscribe('node-clicked', (code) => {
      state.selectedCategory = code
      sessionStorage.setItem('lastFacetUsed', JSON.stringify({ type: FILTER_TYPES.category, id: code }))
      if(code === DEFAULT_CATEGORY_NODE) {
        this.publish('close-all-nodes')
      }
    })
  }

}
</script>

<style lang="scss">
.filter-category-selector {
  overflow-x: auto;
}

.filter-category-selector ul[role="tree"]{
  @include reset-list;
}

</style>
